"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _styles = require("./styles");
var _uiTheme = require("@kyruus/ui-theme");
const StaticMap = _ref => {
  let {
    mapLink,
    smallImage,
    smallHeight,
    mediumImage,
    mediumHeight,
    largeImage,
    largeHeight,
    label,
    theme,
    onClick
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_styles.Container, {
    "data-testid": "StaticMap"
  }, /*#__PURE__*/_react.default.createElement("a", {
    rel: "noreferrer noopener",
    target: "_blank",
    href: mapLink,
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement("picture", null, /*#__PURE__*/_react.default.createElement("source", {
    media: `(max-width: ${(0, _uiTheme.fromTheme)('screen_medium')(theme)})`,
    srcSet: smallImage
  }), /*#__PURE__*/_react.default.createElement("source", {
    media: `(max-width: ${(0, _uiTheme.fromTheme)('screen_large')(theme)})`,
    srcSet: mediumImage
  }), /*#__PURE__*/_react.default.createElement(_styles.MapImage, {
    src: largeImage,
    alt: label,
    smallHeight: smallHeight,
    mediumHeight: mediumHeight,
    largeHeight: largeHeight
  }))));
};
StaticMap.propTypes = {
  // link that clicking the map will open in a new tab
  mapLink: _propTypes.string,
  // map label used for alt text
  label: _propTypes.string.isRequired,
  // small viewport map height
  smallHeight: _propTypes.string.isRequired,
  // map url to use for small viewport
  smallImage: _propTypes.string.isRequired,
  // medium viewport map height
  mediumHeight: _propTypes.string.isRequired,
  // map url to use for medium viewport
  mediumImage: _propTypes.string.isRequired,
  // large viewport map height
  largeHeight: _propTypes.string.isRequired,
  // map url to use for large viewport
  largeImage: _propTypes.string.isRequired,
  // provided by `withTheme` HOC and doesn't need to be passed in explicitly
  theme: _propTypes.object.isRequired,
  onClick: _propTypes.func
};
var _default = exports.default = (0, _uiTheme.withTheme)(StaticMap);
StaticMap.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "StaticMap",
  "props": {
    "mapLink": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "label": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "smallHeight": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "smallImage": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "mediumHeight": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "mediumImage": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "largeHeight": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "largeImage": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "theme": {
      "description": "",
      "type": {
        "name": "object"
      },
      "required": true
    },
    "onClick": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    }
  }
};